var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',{staticClass:"stars-filter"},_vm._l(([1, 2, 3, 4, 5]),function(starNumber){return _c('div',{key:starNumber,class:_vm.hoverStarFilter <= _vm.starFilter &&
      _vm.starFilter > starNumber - 1 &&
      (_vm.hoverStarFilter > starNumber - 1 || _vm.hoverStarFilter == 0)
        ? 'active-star'
        : _vm.hoverStarFilter > starNumber - 1 && _vm.hoverStarFilter >= _vm.starFilter
        ? 'active-star'
        : '',on:{"click":function($event){return _vm.filterStar(starNumber)},"mouseover":function($event){_vm.hoverStarFilter = starNumber},"mouseout":function($event){_vm.hoverStarFilter = 0}}})}),0)}
var staticRenderFns = []

export { render, staticRenderFns }